import {
  assert_false,
  assert_not_null,
  assert_string_not_blank,
  assert_string_not_empty,
  assert_string_object_id,
  assert_string_object_id_not_empty,
} from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { CALLBACK__tool_creator } from '@shared/types/types';
import { UTILS__string } from '@shared/utils/utils_string';
import { timestamp_ms } from '@shared/utils/utils_time';
import { MAP__serializable } from '../_base/MAP__serializable';
import { DTO__database_entity } from '../_database_entity/DTO__database_entity';
import { DTO__generation_tool_grid2d_view } from './DTO__generation_tool_grid2d_view';
import { ENUM__generation_tool_view_name } from './ENUM__generation_tool_view_name';
import { ENUM__field_store_interaction } from './graph_invoke/_fields/_base/_enums/ENUM__field_store_interaction';
import { FIELD__base } from './graph_invoke/_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from './graph_invoke/_graph/DTO_GRAPH__instance';
import { FN_GRAPH__layout_create } from './graph_invoke/_templates/_methods/FN_GRAPH__layout_create';

interface PROPS__view_add {
  name?: string;
  group?: string;
  //
  fields__visible: FIELD__base[];
  fields__stored: FIELD__base[];
  //
  field_row_id?: string;
  field_column_id?: string;
  //
  field_id_info__has_affect_on_generation?: string;
  field_ids_info__items_amount?: string[];
  field_id_info__ml_asset?: string;
}

let PROPS_DEFAULT: PROPS__view_add = {
  name: ENUM__generation_tool_view_name.DEFAULT,
  group: '',
  //
  fields__visible: [],
  fields__stored: [],
  //
  field_row_id: ENUM__string_id_empty.UUID,
  field_column_id: ENUM__string_id_empty.UUID,
  /*
   *
   */
  field_id_info__has_affect_on_generation: ENUM__string_id_empty.UUID,
  field_ids_info__items_amount: [],
  field_id_info__ml_asset: ENUM__string_id_empty.UUID,
};

//todo: save to db and get from db
export class DTO__generation_tool extends DTO__database_entity {
  /*
   *
   */
  static _class_name_static: string = ENUM__dto_class_name.GENERATION_TOOL;

  /*
   *
   */

  static sort_by_name(a: DTO__generation_tool, b: DTO__generation_tool) {
    return a.name.localeCompare(b.name);
  }

  static CREATE_TO_MAP(map: MAP__serializable<string, DTO__generation_tool>, fn_creator: CALLBACK__tool_creator) {
    let tool = DTO__generation_tool.CREATE(fn_creator);

    if (tool.is_stub()) return;

    tool.graph.fields__prepare();
    tool.graph.nodes__prepare();
    tool.graph.output_type__update();
    tool.update_id();

    map.set(tool._id, tool);
  }

  static CREATE(fn_creator: CALLBACK__tool_creator) {
    let tool = fn_creator();

    if (tool.is_stub()) return tool;

    assert_false(tool.graph.is_stub());

    /*
     *
     */

    /*
     *
     */

    return tool;
  }

  /*
   *
   */
  generation_id!: string;

  name!: string;

  graph!: DTO_GRAPH__instance;

  grid2d_view_current_name!: string; //name

  //key - name, showed sorted by name
  grid2d_views_map!: MAP__serializable<string, DTO__generation_tool_grid2d_view>;

  /*
   *
   */

  view__set_current_first() {
    assert_false(this.grid2d_views_map.is_empty());

    let view_name = this.grid2d_views_map.keys()[0];

    this.view__set_current(view_name);
  }

  view__set_current(name: string) {
    if (this.grid2d_view_current_name == name) return;

    let view = this.grid2d_views_map.get_or_assert(name);
    this.grid2d_view_current_name = name;

    /*
     * UI
     */

    this.graph.ui__disable();

    let fields_map = this.graph.fields__get_map();

    for (let field_id of view.fields_visible) {
      let field = fields_map.get_or_assert(field_id);
      field.meta.ui__is_visible = true;
    }

    /*
     * GRID2D
     */

    this.graph.grid2d__dimensions_reset_to_stub();

    if (!view.field_row_id.is_empty_uuid()) this.graph.grid2d__use_as_row(view.field_row_id);
    if (!view.field_column_id.is_empty_uuid()) this.graph.grid2d__use_as_column(view.field_column_id);
  }

  /*
   *
   */

  constructor() {
    super();

    this.graph = DTO_GRAPH__instance.CREATE_STUB();
    this.grid2d_views_map = new MAP__serializable();

    //todo:remove after using db
    this.created_at = timestamp_ms();
    this.updated_at = timestamp_ms();
  }

  init_for_generation(generation_id: string) {
    assert_string_object_id_not_empty(generation_id);

    this.generation_id = generation_id;

    let { graph } = this;

    FN_GRAPH__layout_create(graph);

    graph.fields__update_aliases();

    graph.fields__prepare();

    graph.nodes__prepare();

    graph.output_type__update();

    graph.set_graph_id(generation_id);

    this.update_id();

    if (!this.grid2d_views_map.has(this.grid2d_view_current_name)) this.view__set_current_first();
  }

  update_id() {
    let seed = `${this.name}|${this.graph.meta.output_type}`;

    this._id = UTILS__string.object_id(seed);
  }

  view__add(props: PROPS__view_add) {
    props = { ...PROPS_DEFAULT, ...props };

    let {
      name,
      fields__visible,
      fields__stored,
      field_row_id,
      field_column_id,
      group,
      //
      field_id_info__has_affect_on_generation,
      field_ids_info__items_amount: field_id_info__items_amount,
      field_id_info__ml_asset,
    } = props;

    assert_not_null(name);
    assert_not_null(group);

    assert_not_null(field_row_id);
    assert_not_null(field_column_id);

    assert_not_null(field_id_info__has_affect_on_generation);
    assert_not_null(field_id_info__items_amount);
    assert_not_null(field_id_info__ml_asset);

    this.grid2d_views_map.assert_not_exists(name);

    group = group.trim();

    /*
     *
     */

    for (let field of fields__visible) {
      if (field.meta.store__write_is_enabled()) continue;

      field.meta.store__interaction = ENUM__field_store_interaction.READ_AND_WRITE;
    }

    let fields__visible_ids = fields__visible.map(field => field.meta.field_id);
    fields__visible_ids = fields__visible_ids.unique_values();

    let fields__visible_human_readable = fields__visible.map(field => field.meta.field_path_full_human_readable);

    /*
     * FIELDS VISIBLE
     */

    let tool_view = new DTO__generation_tool_grid2d_view();
    [tool_view.name, tool_view.group] = [name, group];

    /*
     *
     */
    tool_view.fields_stored = fields__stored.map(field => field.meta.field_id);

    tool_view.field_id_info__has_affect_on_generation = field_id_info__has_affect_on_generation;
    tool_view.field_ids_info__items_amount = field_id_info__items_amount;
    tool_view.field_id_info__ml_asset = field_id_info__ml_asset;

    /*
     *
     */

    /*
     *
     */
    tool_view.fields_visible = fields__visible_ids;
    tool_view.fields_visible__human_readable = fields__visible_human_readable;
    //todo:remove
    if (fields__visible_human_readable.some(item => item.includes('undefined'))) debugger;
    /*
     * GRID2D
     */

    [tool_view.field_row_id, tool_view.field_column_id] = [field_row_id, field_column_id];

    this.grid2d_views_map.set(tool_view.name, tool_view);
  }

  toString() {
    let out = this.name;

    if (this.grid2d_view_current_name != ENUM__generation_tool_view_name.DEFAULT) {
      out += `.${this.grid2d_view_current_name}`;
    }

    return out;
  }

  /*
   *
   */

  assert_standard_fields() {
    assert_string_object_id(this.generation_id);

    assert_string_not_blank(this.name);

    assert_string_not_empty(this.grid2d_view_current_name);

    this.grid2d_views_map.get_or_assert(this.grid2d_view_current_name); //check existance
  }
}
